
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import DeleteDialog from '@/components/uicomp/ModalDialog-Delete'
import TableOptionsDialog from './ListOptionsDialog'
const components = {
  DeleteDialog,
  TableOptionsDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  list: `Product/Item/list`,
  meta: `Product/Item/listMeta`,
  auth: `Auth/model`,
})

computed.canEdit = function () {
  return this.auth.hasPermission('ACCESS_CATITEM_M')
}

computed.canSeeAssetPrice = function () {
  return this.auth.hasPermission('ACCESS_CATITEM_ASSETPRICE')
}

computed.canSeeSalePrice = function () {
  return this.auth.hasPermission('ACCESS_CATITEM_SALEPRICE')
}

computed.canSeeStorePrice = function () {
  return this.auth.hasPermission('ACCESS_CATITEM_STOREPRICE')
}

/**
 * Methods
 *
 */
const methods = mapActions({
  setListOption: `Product/Item/setListOption`,
  reload: `Product/Item/fetchList`,
  updateData: `Product/Item/update`,
  pagePrev: `Product/Item/pagePrev`,
  pageNext: `Product/Item/pageNext`,
  deleteItem: `Product/Item/remove`,
})

methods.edit = function (id) {
  this.$router.push(`/product/item/${id}`)
}

methods.editCover = function (id) {
  this.$router.push(`/product/item/${id}/cover`)
}

methods.editValue = function (id, property, value) {
  this.updateData({
    id,
    data: { [property]: value },
  })
}

methods.showopt = function () {
  this.$refs.TableOptionsDialog.show()
}

methods.search = function (value) {
  this.setListOption({
    search: value,
    pagenumber: 1,
  })
}

/**
 * Watch
 *
 */
const watch = {
  meta: {
    deep: true,
    handler(n, o) {
      n.version !== o.version && this.reload()
    },
  }
}

/**
 * Event OnMounted
 *
 */
const mounted = async function() {
  this.setListOption({ format: `deep` })
}

/**
 * Event OnCreated
 *
 */
const created = async function() {
  //
}

/**
 * Event Socket
 *
 */
const sockets = {
  SALES_DATA_UPDATED: function () {
    this.reload()
  },
  EXPENDITURE_DATA_UPDATED: function () {
    this.reload()
  },
  PRODTRX_DATA_UPDATED: function () {
    this.reload()
  },
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
  mounted,
  created,
  sockets,
}
</script>

<style scoped>
  .bg-green {
    background-color: #80ef7324;
  }
  .bg-orange {
    background-color: #f1bd6e40;
  }
</style>

<template>
  <Row>
    <TableOptions
      :nrecord="meta.nrecord"
      :npage="meta.npage"
      :curpage="meta.curpage"
      :searchValue="meta.filter.search"
      @nextpage="pageNext"
      @prevpage="pagePrev"
      @showopt="showopt"
      @search="search"
    />
    <TableOptionsDialog ref="TableOptionsDialog"
    />

    <TableList>
      <template #head>
        <th width="40" class="text-center">#</th>
        <th width="140" class="text-left">Kategori</th>
        <th width="80" class="text-left">Foto</th>
        <th class="text-left">Nama Produk</th>
        <th width="80" class="text-right">Stok Ada</th>
        <th width="80" class="text-right" v-if="canSeeAssetPrice">H. Beli<br>Toko</th>
        <th width="80" class="text-right" v-if="canSeeSalePrice">H. Jual<br>ke Plg</th>
        <th width="80" class="text-right" v-if="canSeeStorePrice">H. Jual<br>ke Toko</th>
        <!-- <th width="80" class="text-right">Komisi Reseller</th> -->
        <th width="40" class="text-right" v-if="canEdit"></th>
      </template>

        <template #body>
        <tr v-for="(item, index) in list" :key="item.id">
          <td class="text-center" v-html="index + meta.curstart"></td>
          <td class="text-left" v-html="item.category_name || '-'"></td>
          <td class="text-left">
            <img class="link" height="64" width="64" v-if="canEdit"
              :src="item.cover"
              @click="editCover(item.id)" />

            <img height="64" width="64" v-else
              :src="item.cover"
              @click="editCover(item.id)" />
          </td>
          <td class="text-left">
            <router-link v-if="canEdit" class="link underlined" :to="`/product/item/${item.id}`">
              {{ item.name }}
            </router-link>

            <span v-else>
              {{ item.name }}
            </span>

            <p style="margin-top: 10px"></p>
            <p class="subdata">{{ item.description }}</p>
            <p style="margin-top: 10px"></p>
            <p class="subdata">
              <label class="label label-info push-5-r">
                <fa-tag t="Brand" />
              </label>
              {{ item.brand_name }}
            </p>
            <p class="subdata">
              <label class="label label-info push-5-r">
                <fa-truck t="Supplier" />
              </label>
              {{ item.supplier_name }}
            </p>
            <p style="margin-top: 10px"></p>
          </td>
          <td class="text-center">
            {{ item.current_stock }}
            /
            {{ item.minimum_stock }}
            <br>
            <br>
            <Label c="warning" t="Overload" v-if="item.current_stock > item.minimum_stock">
              + {{ item.current_stock - item.minimum_stock }}
            </Label>
            <Label c="danger" t="Kurang" v-if="item.current_stock < item.minimum_stock">
              {{ item.current_stock - item.minimum_stock }}
            </Label>
          </td>
          <td class="text-right" v-if="canSeeAssetPrice">
            <TextFieldChangable v-if="canEdit"
              allow="0-9"
              :forceupper=true
              :value="item.price_asset_readable"
              @submit="editValue(item.id, `price_asset`, $event)"/>

              <span v-else>{{ item.price_asset_readable }}</span>
          </td>
          <td class="text-right bg-green" v-if="canSeeSalePrice">
            <TextFieldChangable v-if="canEdit"
              allow="0-9"
              :forceupper=true
              :value="item.price_unit_readable"
              @submit="editValue(item.id, `price_unit`, $event)"/>

              <span v-else>{{ item.price_unit_readable }}</span>
          </td>
          <td class="text-right bg-orange" v-if="canSeeStorePrice">
            <TextFieldChangable v-if="canEdit"
              allow="0-9"
              :forceupper=true
              :value="item.price_store_readable"
              @submit="editValue(item.id, `price_store`, $event)"/>

              <span v-else>{{ item.price_store_readable }}</span>
          </td>
          <!-- <td class="text-right">
            {{ item.resell_commission_readable }}
          </td> -->
          <td class="text-right" v-if="canEdit">
            <TButtonDelete @click="$refs.DeleteDialog.confirm(item.id, item.name)" />
          </td>
        </tr>
      </template>
    </TableList>

    <DeleteDialog ref="DeleteDialog" @submit="deleteItem($event)" />
  </Row>
</template>